module.exports = "<img src=\"assets/footer.png\" alt=\"footer\" width=\"100%\" height=\"auto\" class=\"hidden-xs\">\n<img src=\"assets/footer-mobile.png\" alt=\"footer\" width=\"100%\" height=\"auto\" class=\"hidden-sm hidden-md hidden-lg hidden-xl\">"


//////////////////
// WEBPACK FOOTER
// /Users/enzo/Desktop/capsycofr-angular/src/app/components/footer/footer.component.html
// module id = ../../../../../src/app/components/footer/footer.component.html
// module chunks = main